import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import('../views/Home.vue'),
		redirect: '/login', //重定向
		children: [
			{
				path: '/index',
				name: 'index',
				redirect: '/index/task', //重定向
				meta: { title: '首页' },
				component: () => import('../views/Home.vue'),
				children: [
					{
						path: '/index/statistical',
						name: 'statistical',
						meta: { title: '外呼统计' },
						component: () => import('../views/Statistical/statistical.vue')
					},
					{
						path: '/index/lineSet',
						name: 'statistical',
						meta: { title: '线路分配' },
						component: () => import('../views/lineSet/lineSet.vue')
					},
					{
						path: '/index/setvip',
						name: 'viplist',
						meta: { title: 'vip名单' },
						component: () => import('../views/SetVip/setvip.vue')
					},
					{
						path: '/index/LookPersion',
						name: 'LookPersion',
						meta: { title: '查看开通人员' },
						component: () => import('../views/LookPersion/LookPersion.vue')
					},
					{
						path: '/index/callHistoryPersion',
						name: 'callHistoryPersion',
						meta: { title: '通话记录' },
						component: () => import('../views/callHistoryPersion/callHistoryPersion.vue')
					},
					{
						path: '/index/task',
						name: 'task',
						meta: { title: '外呼任务' },
						component: () => import('../views/Task/task.vue')
					},
					{
						path: '/index/callLog',
						name: 'statistical',
						meta: { title: '通话记录' },
						component: () => import('../views/CallLog/callLog.vue')
					},
					{
						path: '/index/mycustomer',
						name: 'mycustomer',
						meta: { title: '我的客户' },
						component: () => import('../views/Mycustomer/mycustomer.vue')
					},
					{
						path: '/index/customersea',
						name: 'customersea',
						meta: { title: '客户公海' },
						component: () => import('../views/Customersea/customersea.vue')
					},
					{
						path: '/index/addtask',
						name: 'customersea',
						meta: { title: '新建任务' },
						component: () => import('../views/Addtask/addtask.vue')
					},
					{
						path: '/index/entertask',
						name: 'customersea',
						meta: { title: '进入任务' },
						component: () => import('../views/Entertask/entertask.vue')
					},
					{
						path: '/index/setting',
						name: 'sysSetting',
						meta: { title: '人员设置' },
						component: () => import('../views/sys/setting.vue')
					},
					{
						path: '/index/synchronize',
						name: 'synchronize',
						meta: { title: '同步数据' },
						component: () => import('../views/synchronize/synchronize.vue')
					}

				]
			}
		]
	},
	{
		path: '/newkong',
		name: 'newkong',
		meta: { title: '已在浏览器打开' },
		component: () => import('../views/newkong.vue')
	},
	{
		path: '/login',
		name: 'login',
		meta: { title: '外呼统计登陆页' },
		component: () => import('../views/Login/login.vue')
	},
]

const router = new VueRouter({
	// mode: 'history',
	routes
})



export default router
